var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-container",class:[{
             'is-paddingless-mobile': _vm.paddinglessMobile,
             'is-fluid': _vm.fluid,
             'no-padding':_vm.noPadding
           }, 
           _vm.size 
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }